import { FieldOptionBase } from 'api/tasks';
import { UserOption } from 'components/molecules/squad-picker';
import { useGetAllActiveUsers, useGetAllMembersInProject } from 'hooks/use-idb';

export const useFilterUserOptions = ({
  projectId,
}: {
  projectId?: number;
}): FieldOptionBase<number>[] => {
  const usersInProject = useGetAllMembersInProject({
    projectId,
  });

  const activeUsers = useGetAllActiveUsers();

  const users = projectId ? usersInProject : activeUsers;

  return users.map((user) => ({
    ...UserOption(user),
    value: user.userId,
  }));
};
